import { Modal, Button, Switch, Form } from 'antd';
import React, { useState } from 'react';
import {
  VerificarSeBmEDoTipoAutomaticoEtemFrequenciaSlaSobDemanda,
  AprovarComRessalvaAnaliseQuantitativa,
  VerificarLinhasBMPreenchidas,
} from '@app/api/boletimMedicao';
import { Input, Tooltip } from 'antd';
import { FormSwitch } from '@digital/ui';
const { TextArea } = Input;

interface ModalAprovacao {
  id: any;
  atualizarAbas: () => any;
  onCreateAba: () => any;
  history: any;
}

const ModalAprovacaoComResalvaAnaliseQuantitativa = (props: ModalAprovacao) => {
  const { id, atualizarAbas, onCreateAba, history } = props;
  const [openModal, setOpenModal] = useState(false);
  const [mostrarBotaoSla, setmostrarBotaoSla] = useState(false);

  return (
    <div>
      <Tooltip title="Direcionar o BM para avaliação do gestor MRN indicando a ressalva">
        <Button
          type="link"
          icon="hands-thumbs_up"
          onClick={() => {
            VerificarLinhasBMPreenchidas(id).then(data => {
              if (data) {
                if (data.value === false) {
                  Modal.confirm({
                    title: 'Linhas do BM pendentes',
                    content:
                      'Não é possível avançar o processo. Foram identificadas linhas com pendência de lançamento e aprovação.',
                    cancelText: 'Cancelar',
                    onCancel: () => {},
                    okText: 'Visualizar pendências',
                    onOk: () => {
                      onCreateAba();
                      history.push(`/boletimDeMedicoes/detail/${id}/pendencias`);
                    },
                  });
                } else {
                  VerificarSeBmEDoTipoAutomaticoEtemFrequenciaSlaSobDemanda(id).then(data => {
                    if (data) {
                      if (data === true) {
                        setmostrarBotaoSla(data);
                      }
                    }
                    setOpenModal(true);
                  });
                }
              }
            });
          }}>
          APROVAR COM RESSALVA {/* Aprovar com ressalva análise quantitativa do BM */}
        </Button>
      </Tooltip>

      <Modal
        title="   Aprovar com ressalva análise quantitativa do BM"
        visible={openModal}
        onOk={() => {
          let textoJustificativa = '';
          let medicaoAnaliseSla = 'false';
          let textJustificativa = document.getElementById('justificativa');
          let valorMedicaoAnaliseSla = document.getElementById('imputMedicaoAnaliseSla');

          if (textJustificativa != undefined) {
            textoJustificativa = textJustificativa.value;
          }

          if (valorMedicaoAnaliseSla != undefined) {
            medicaoAnaliseSla = valorMedicaoAnaliseSla.value;
          }

          let form = new FormData();
          form.append('medicaoId', id);
          form.append('Justificativa', textoJustificativa);
          form.append('medicaoAnaliseSla', medicaoAnaliseSla);

          AprovarComRessalvaAnaliseQuantitativa(id, form).then(data => {
            if (data) {
              if (data.valid) {
                setOpenModal(false);
                atualizarAbas();
              }
            }
          });
        }}
        onCancel={() => {
          setOpenModal(false);
        }}>
        <TextArea
          name="justificativa"
          id="justificativa"
          onChange={() => {}}
          placeholder="informe a justificativa"
          rows={3}
        />
        {mostrarBotaoSla ? (
          <>
            <Form.Item label="Medição terá Análise de SLA">
              <Switch defaultChecked onChange={() => {}} />
            </Form.Item>
          </>
        ) : (
          <> </>
        )}
      </Modal>
    </div>
  );
};

export default ModalAprovacaoComResalvaAnaliseQuantitativa;
